import {isDa1AuthUniversalLoginHost, isDa1LegacyMarketingLoginHost} from 'common/HelperFunctions'
import Constants from 'common/constants'

import {
  FORGOT_PASSWORD,
  REQUEST_PASSWORD_RESET_OTP,
  RESET_DEFAULT_PASSWORD,
  RESET_PASSWORD,
  VERIFY_PASSWORD_RESET_GOOGLE,
  VERIFY_PASSWORD_RESET_OTP,
} from './ActionTypes/ApiActionTypes'

const passwordResetPayloadBase = () => ({
  noAccessToken: true,
  getString: '',
  useBaseURL: true,
  requestType: 'POST',
  header: 'application/json',
  omitDomainHeader: isDa1AuthUniversalLoginHost() || isDa1LegacyMarketingLoginHost(),
  reduxActionType: '',
})

export const forgotPassword = (email, resend, onSuccess, onFailure) => {
  return {
    type: FORGOT_PASSWORD,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: Constants.api_forgot_password,
      noAccessToken: true,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {
        email: email,
        resend,
      },
      reduxActionType: '',
    },
  }
}

export const resetPassword = (body, onSuccess, onFailure) => {
  return {
    type: RESET_PASSWORD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_reset_password,
      noAccessToken: true,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const requestPasswordResetOtp = (email, applicationId, onSuccess, onFailure) => {
  const body = {email}
  if (applicationId != null) {
    body.applicationId = applicationId
  }

  return {
    type: REQUEST_PASSWORD_RESET_OTP,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_forgot_password,
      body,
      ...passwordResetPayloadBase(),
    },
  }
}

export const verifyPasswordResetOtp = (email, otp, applicationId, onSuccess, onFailure) => {
  const body = {email, otp}
  if (applicationId != null) {
    body.applicationId = applicationId
  }

  return {
    type: VERIFY_PASSWORD_RESET_OTP,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_verify_password_reset_otp,
      body,
      ...passwordResetPayloadBase(),
    },
  }
}

export const verifyPasswordResetGoogle = (idToken, applicationId, onSuccess, onFailure, email) => {
  const body = {idToken}
  if (applicationId != null) {
    body.applicationId = applicationId
  }
  if (email) {
    body.email = email
  }

  return {
    type: VERIFY_PASSWORD_RESET_GOOGLE,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_verify_password_reset_google,
      body,
      ...passwordResetPayloadBase(),
    },
  }
}

export const resetDefaultPassword = (newPassword, onSuccess, onFailure) => {
  return {
    type: RESET_DEFAULT_PASSWORD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_reset_default_password,
      noAccessToken: false,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {newPassword},
      reduxActionType: '',
    },
  }
}
